export const AdobeClientDataLayer = () => {
  return <div />;
};
